// @flow
import moment from 'moment';
import i18n from 'i18n-js';

import * as routesActions from '../../actions/routes';

export const validate = (values: Object) => {
  const {
    name,
    route_type,
    week_days,
    expected_departure_time,
    expected_completion_time,
    monitor,
    driver,
    bus,
  } = values;

  const errors = {};

  if (!name) {
    errors.name = i18n.t('labels.requiredField');
  }

  if (!route_type) {
    errors.type = i18n.t('labels.requiredField');
  }

  if (!monitor || !monitor.id) {
    errors.monitor = i18n.t('labels.requiredField');
  }

  if (!driver || !driver.id) {
    errors.driver = i18n.t('labels.requiredField');
  }

  if (!bus || !bus.id) {
    errors.bus = i18n.t('labels.requiredField');
  }

  if (!week_days || week_days.length === 0) {
    errors.week_days = 'Selecciona al menos un día.';
  }

  if (!expected_departure_time) {
    errors.expected_departure_time = i18n.t('labels.requiredField');
  }

  if (!expected_completion_time) {
    errors.expected_completion_time = i18n.t('labels.requiredField');
  }

  return errors;
};

export const onSubmit = (values: Object, dispatch: Function, props: Object) => {
  const {
    routeId,
  } = props;
  const {
    name,
    route_type,
    week_days,
    expected_departure_time,
    expected_completion_time,
    monitor,
    driver,
    bus,
    edit,
  } = values;

  const dep_time = moment(expected_departure_time, ['h:m a', 'H:m']).utc().format('HH:mm').toString();
  const comp_time = moment(expected_completion_time, ['h:m a', 'H:m']).utc().format('HH:mm').toString();

  if (!edit) {
    dispatch(routesActions.createRouteStarted(
      name,
      route_type,
      monitor.id,
      driver.id,
      bus.id,
      week_days,
      dep_time,
      comp_time,
    ));
  } else {
    dispatch(routesActions.updateRouteStarted({
      name: values.name,
      short_name: values.name,
      route_type,
      monitor: monitor.id,
      driver: driver.id,
      bus: bus.id,
      week_days,
      expected_departure_time: dep_time,
      expected_completion_time: comp_time,
      routeId,
      id: routeId,
      }
    ));
  }
};



// WEBPACK FOOTER //
// ./src/scripts/components/CreateRoutePopupForm/utils.js